import React from "react"
import {BlobProvider} from "@react-pdf/renderer"
import {connect} from "react-redux"

import ComponentWithData from "~/utils/ComponentWithData"
import {getDeliveryNote} from "~/utils/ShelfEntities"
import DeliveryNote from "~/components/pdf/DeliveryNote"
import {Button, ListItemStockOut, List} from "~/components/"
import {withTranslation} from "react-i18next"

class DeliveryNoteDetailView extends ComponentWithData {
  getData() {
    return getDeliveryNote(this.props.match.params.delivery_note_number)
  }

  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }

  renderError() {
    return (
      <p>
        {this.props.t("error")} {console.log(this.state.error)}
      </p>
    )
  }

  renderEmpty() {
    return <p>{this.props.t("deliveryNotes.notFound")}</p>
  }

  renderPdfButton = ({blob, url}) => (
    <Button primary>
      <a href={url} target="_blank" rel="noreferrer noopener">
        {this.props.t("deliveryNotes.downloadPdf")}
      </a>
    </Button>
  )

  renderWithData() {
    const Doc = (
      <DeliveryNote
        tenantName={this.props.subdomain}
        number={this.state.data.number}
        stock_outs={this.state.data.stock_outs}
      />
    )

    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">
            {this.props.t("deliveryNotes.deliveryNote")} «
            <strong>{this.state.data.number}</strong>»
          </div>

          <div className="actions">
            <BlobProvider document={Doc}>{this.renderPdfButton}</BlobProvider>
          </div>
        </div>

        <List
          items={this.state.data.stock_outs}
          itemRenderer={ListItemStockOut}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {subdomain} = user
  return {subdomain}
}

export default withTranslation(connect(mapStateToProps)(DeliveryNoteDetailView))



// WEBPACK FOOTER //
// ./src/views/detail/DeliveryNoteDetailView.js